import { ExclamationCircleOutlined } from '@ant-design/icons';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "block",
  },
  textField: {
    width: "100%",
    lineHeight: "1.1 !important",
  },
  label: {
    fontSize: 12,
  },
  formControl: {
    display: "flex",
    minWidth: 120,
    "& label.Mui-focused": {
      color: "#646BDB",
      fontSize: "12px !important",
      fontWeight: "300 !important", //regular
      lineHeight: "12px !important",
    },
    "& .MuiSelect-select": {
      fontSize: "14px !important",
      fontWeight: "500 !important", //semibold
    },
    "& .MuiOutlinedInput-inputSelect": {
      padding: "0 !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "16px !important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#646BDB",
    },
    "& .MuiFormLabel-root": {
      fontSize: "12px !important",
      fontWeight: "300 !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#D6D6D6",
        borderWidth: 1,
      },
      "&:hover fieldset": {
        borderColor: "#929090",
        color: "#929090",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#646BDB",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      "& legend": {
        borderBottom: "none !important",
      },
    },
    "& .MuiFormHelperText-root": {
      "& .error-text": {
        fontSize: 10,
      },
    },
    "& .MuiMenu-paper": {
      height: "200 !important",
    },
    "& .MuiPopover-paper": {
      height: "200 !important",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function CustomSelect(props) {
  const classes = useStyles();
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={props.required && props.value.length <= 0}
    >
      <InputLabel
        ref={inputLabel}
        className={classes.label}
        id="demo-simple-select-outlined-label"
      >
        {props.label}
      </InputLabel>
      <Select
        disabled={props.disabled}
        id="demo-simple-select-outlined"
        labelId="demo-simple-select-outlined-label"
        className={classes.textField}
        value={props.value}
        onChange={(event) => props.onSelect(event.target.value)}
        onClick={(event)=> {
          if(props.onClick && props.disabled){
             props.onClick()
            }}
          }
        labelWidth={labelWidth}
      >
        {props.options.map((option) => (
          <MenuItem
            style={{ fontSize: "16px" }}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {!props.custom ? (
        props.required || props.value.length <= 0 ? (
          <FormHelperText>
            <div className="error-text">
              <ExclamationCircleOutlined className="error-text-icon" />
              please select {props.label.toLowerCase()}
            </div>
          </FormHelperText>
        ) : null
      ) : (
        ""
      )}
    </FormControl>
  );
}
